/**
 * MORNING FIX COFFEE
 * BUILD #9 — BUILD MY COFFEE / TASTE PROFILE QUIZ
 * VERSION 1.0.0
 *
 * Responsibility:
 * Customer journey only:
 * START → QUESTION → ANSWER → NEXT → … → COMPLETE
 * → CART-READY TASTE PROFILE LANDING PAGE.
 *
 * Build #1 owns scoring/profile calculation.
 * Build #8 owns the production handoff.
 * No separate result screen is created here.
 */
(function (window, document) {
  'use strict';

  const VERSION = '1.0.0';
  const BUILD = 9;
  const TOTAL_QUESTIONS = 10;

  const DEFAULT_CONFIG = {
    containerId: 'coffee-taste-profile',
    title: 'Build My Coffee',
    subtitle: 'Answer a few questions and we’ll find the coffee that fits your taste.',
    startButtonText: 'Build My Coffee',
    nextButtonText: 'Next',
    finalButtonText: 'See My Coffee',
    loadingText: 'Building your coffee profile...',
    errorText: 'We couldn’t complete the quiz right now. Please try again.',
    restartText: 'Start Again',
    progressLabel: 'Question {current} of {total}',
    completionConfig: {}
  };

  const state = {
    initialized: false,
    started: false,
    completed: false,
    busy: false,
    destroyed: false,
    profile: null,
    currentQuestion: null,
    questionNumber: 0,
    container: null,
    config: null
  };

  function getEngine() {
    if (!window.CoffeeProfile) throw new Error('Build #9 requires Build #1: CoffeeProfile.');
    ['createProfile', 'getNextQuestion', 'answer'].forEach(function (name) {
      if (typeof window.CoffeeProfile[name] !== 'function') {
        throw new Error('Build #1 ' + name + '() is unavailable.');
      }
    });
    return window.CoffeeProfile;
  }

  function getProduction() {
    if (!window.CoffeeProductionController) {
      throw new Error('Build #9 requires Build #8: CoffeeProductionController.');
    }
    if (typeof window.CoffeeProductionController.startWithProfile !== 'function') {
      throw new Error('Build #8 startWithProfile() is unavailable.');
    }
    return window.CoffeeProductionController;
  }

  function mergeConfig(config) {
    return Object.assign({}, DEFAULT_CONFIG, config || {});
  }

  function resolveContainer(container) {
    if (container && typeof container === 'string') container = document.querySelector(container);
    if (container && container.nodeType) return container;
    const id = state.config && state.config.containerId;
    const found = id ? document.getElementById(id) : null;
    if (found) return found;
    throw new Error('Build #9 quiz container not found.');
  }

  function esc(value) {
    return String(value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function progress() {
  var total = state.questionNumber <= 10 ? 10 : 15;

  return state.config.progressLabel
    .replace('{current}', state.questionNumber)
    .replace('{total}', total);
}

  function renderStart() {
    state.container.innerHTML = `
      <div class="coffee-quiz coffee-quiz-start">
        <div class="coffee-quiz-content">
        <img
          class="coffee-quiz-opening-image"
          src="https://cdn.shopify.com/s/files/1/0774/7656/1045/files/Build_1-Build_My_Coffee_Opening_Image.png?v=1787412355"
          alt="Morning Fix Coffee"
          loading="eager"
        >
          <div class="coffee-quiz-eyebrow">✨ MORNING FIX COFFEE</div>
          <h1>${esc(state.config.title)}</h1>
          <p>${esc(state.config.subtitle)}</p>
          <button type="button" data-action="start">${esc(state.config.startButtonText)}</button>
        </div>
      </div>`;
    state.container.querySelector('[data-action="start"]').addEventListener('click', startQuiz);
  }

  function startQuiz() {
    if (state.busy || state.started) return;
    state.profile = getEngine().createProfile();
    state.started = true;
    state.completed = false;
    state.questionNumber = 0;
    loadNextQuestion();
  }

  function loadNextQuestion() {
  /*
     Target: 10 questions.
     Hard maximum: 15 questions.

     Once the target is reached, stop immediately if the
     profile is complete. Otherwise allow the adaptive engine
     to continue until the hard maximum.
  */

  if (
    state.questionNumber >= 10 &&
    state.profile &&
    state.profile.complete === true
  ) {
    return completeQuiz();
  }

  if (state.questionNumber >= 15) {
    return completeQuiz();
  }

  const question = getEngine().getNextQuestion(state.profile);

  if (!question) {
    return completeQuiz();
  }

  state.currentQuestion = question;
  state.questionNumber += 1;

  renderQuestion();
}

  function renderQuestion() {
    const q = state.currentQuestion;
    state.container.innerHTML = `
      <div class="coffee-quiz coffee-quiz-question">
        <div class="coffee-quiz-content">
          <div class="coffee-quiz-progress">${esc(progress())}</div>
          <div class="coffee-quiz-category">${esc(q.category || 'taste')}</div>
          <h2>${esc(q.question)}</h2>
          <div class="coffee-quiz-answers" role="radiogroup"></div>
          <div class="coffee-quiz-actions">
            <button type="button" data-action="next" disabled>
              ${esc(
  state.questionNumber >= 10 && state.profile && state.profile.complete === true
    ? state.config.finalButtonText
    : state.config.nextButtonText
)}
            </button>
          </div>
        </div>
      </div>`;

    const answers = state.container.querySelector('.coffee-quiz-answers');
    q.answers.forEach(function (answer) {
      const label = document.createElement('label');
      label.className = 'coffee-quiz-answer';
      label.innerHTML = `
        <input type="radio" name="coffee-quiz-answer" value="${esc(answer.id)}">
        <span>${esc(answer.label)}</span>`;
      answers.appendChild(label);
    });

    answers.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!state.busy) state.container.querySelector('[data-action="next"]').disabled = false;
      });
    });

    state.container.querySelector('[data-action="next"]').addEventListener('click', submitAnswer);
  }

  function submitAnswer() {
    if (state.busy || !state.profile || !state.currentQuestion) return;
    const selected = state.container.querySelector('input[name="coffee-quiz-answer"]:checked');
    if (!selected) return;

    state.busy = true;
    try {
      getEngine().answer(state.profile, state.currentQuestion.id, selected.value);
      state.container.querySelectorAll('input[name="coffee-quiz-answer"]').forEach(function (input) { input.disabled = true; });
      state.container.querySelector('[data-action="next"]').disabled = true;
      state.busy = false;
      loadNextQuestion();
    } catch (error) {
      state.busy = false;
      renderError(error);
    }
  }

  function completeQuiz() {
    if (state.completed || !state.profile) return;
    if (state.profile.complete !== true) {
      return renderError(new Error('The quiz ended without producing a completed coffee profile.'));
    }

    state.busy = true;
    state.container.innerHTML = `
      <div class="coffee-quiz coffee-quiz-loading">
        <div class="coffee-quiz-content"><h2>${esc(state.config.loadingText)}</h2></div>
      </div>`;

    try {
      const result = getProduction().startWithProfile(
        state.profile,
        state.container,
        state.config.completionConfig
      );
      state.completed = true;
      state.busy = false;
      return result;
    } catch (error) {
      state.busy = false;
      renderError(error);
      throw error;
    }
  }

  function renderError(error) {
    state.container.innerHTML = `
      <div class="coffee-quiz coffee-quiz-error">
        <div class="coffee-quiz-content">
          <h2>${esc(state.config.errorText)}</h2>
          <button type="button" data-action="restart">${esc(state.config.restartText)}</button>
        </div>
      </div>`;
    state.container.querySelector('[data-action="restart"]').addEventListener('click', reset);
    if (typeof console !== 'undefined') console.error('Build #9:', error);
  }

  function start(options) {
    options = options || {};
    if (state.initialized && !state.destroyed) return API;

    state.config = mergeConfig(options.config);
    state.container = resolveContainer(options.container);

    // Validate the real locked contracts before presenting the quiz.
    getEngine();
    getProduction();

    state.initialized = true;
    state.started = false;
    state.completed = false;
    state.busy = false;
    state.destroyed = false;
    state.profile = null;
    state.currentQuestion = null;
    state.questionNumber = 0;

    renderStart();
    return API;
  }

  function reset() {
    state.started = false;
    state.completed = false;
    state.busy = false;
    state.profile = null;
    state.currentQuestion = null;
    state.questionNumber = 0;
    state.destroyed = false;
    if (state.container) renderStart();
    return true;
  }

  function destroy() {
    if (state.container) state.container.innerHTML = '';
    state.initialized = false;
    state.started = false;
    state.completed = false;
    state.busy = false;
    state.destroyed = true;
    state.profile = null;
    state.currentQuestion = null;
    state.questionNumber = 0;
    state.container = null;
    state.config = null;
    return true;
  }

  function getState() {
    return {
      version: VERSION,
      build: BUILD,
      initialized: state.initialized,
      started: state.started,
      completed: state.completed,
      busy: state.busy,
      destroyed: state.destroyed,
      questionNumber: state.questionNumber,
      totalQuestions: TOTAL_QUESTIONS,
      currentQuestionId: state.currentQuestion ? state.currentQuestion.id : null,
      answeredQuestions: state.profile && Array.isArray(state.profile.answeredQuestions)
        ? state.profile.answeredQuestions.length : 0,
      hasProfile: !!state.profile,
      profileComplete: !!(state.profile && state.profile.complete === true)
    };
  }

  function validate() {
    const errors = [];
    if (typeof window === 'undefined') errors.push('Browser window is unavailable.');
    if (typeof document === 'undefined') errors.push('Browser document is unavailable.');

    if (typeof window !== 'undefined') {
      if (!window.CoffeeProfile) errors.push('Build #1 CoffeeProfile is unavailable.');
      else {
        if (typeof window.CoffeeProfile.createProfile !== 'function') errors.push('Build #1 createProfile() is unavailable.');
        if (typeof window.CoffeeProfile.getNextQuestion !== 'function') errors.push('Build #1 getNextQuestion() is unavailable.');
        if (typeof window.CoffeeProfile.answer !== 'function') errors.push('Build #1 answer() is unavailable.');
      }

      if (!window.CoffeeProductionController) errors.push('Build #8 CoffeeProductionController is unavailable.');
      else if (typeof window.CoffeeProductionController.startWithProfile !== 'function') errors.push('Build #8 startWithProfile() is unavailable.');
    }

    return {
      valid: errors.length === 0,
      version: VERSION,
      build: BUILD,
      totalQuestions: TOTAL_QUESTIONS,
      dependencies: {
        build1: typeof window !== 'undefined' && !!window.CoffeeProfile,
        build8: typeof window !== 'undefined' && !!window.CoffeeProductionController
      },
      errors: errors
    };
  }

  const API = {
    version: VERSION,
    build: BUILD,
    start,
    reset,
    destroy,
    getState,
    validate
  };

  if (typeof window !== 'undefined') window.CoffeeTasteQuiz = API;

})(window, document);
